import withIcon from './NewIcon';
// @ts-ignore
import IconSpoonM from './icon/m/spoon.s.svg';

export default withIcon(IconSpoonM);
